export const CURRENCIES = [
    'USD', 'EUR', 'CAD', 'GBP', 'AUD', 'JPY', 'CHF', 'SEK', 'DKK', 'BRL', 'NZD', 'CZK', 'RUB'
]

export const CURRENCIES_OBJECT = Object.fromEntries(CURRENCIES.map(p => [p, '']));